export default __webpack_public_path__ + "static/media/IMG-20240822-WA0020.0af15757.jpg";